module.exports = __webpack_public_path__ + "media/images/portal-77b8b2ce.png";